var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfdas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.1 55.1",
    style: {
      enableBackground: "new 0 0 167.1 55.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D1D1B;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,14.5h-8.1v-0.6c0-6.2,5.6-10.8,14.4-10.8c8.9,0,14.3,5.2,14.3,12.4v22.1h-4.8l-3.2-4.9 c-1.6,2.6-4.8,5.3-10.6,5.3c-6.5,0-11.2-4.2-11.2-10.3c0-7.6,5.7-11,14.4-11h7.4v-1.3c0-2.9-2.1-5.8-6.4-5.8 c-3.6,0-6.2,1.7-6.2,4.2V14.5z M123.6,23.7l0-2.7c-5.1,0-13.8-0.9-13.8,5.7c0,3.3,2.6,5.1,5.2,5.1 C119.4,31.8,123.6,28.2,123.6,23.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,14.5H7.3v-0.6c0-6.2,5.6-10.8,14.4-10.8C30.6,3.1,36,8.3,36,15.5v22.1h-4.8l-3.2-4.9 c-1.6,2.6-4.8,5.3-10.6,5.3c-6.5,0-11.2-4.2-11.2-10.3c0-7.6,5.7-11,14.4-11h7.4v-1.3c0-2.9-2.1-5.8-6.4-5.8 c-3.6,0-6.2,1.7-6.2,4.2V14.5z M27.9,23.7l0-2.7c-5.1,0-13.8-0.9-13.8,5.7c0,3.3,2.6,5.1,5.2,5.1C23.8,31.8,27.9,28.2,27.9,23.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,10.9v5.8h14.2v7.2H48.3v13.7h-8.1v-34h24.5v7.3H48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.1,27.9c0-2.2-3.3-3.3-7-4.6c-5.9-2-10.8-3.9-10.8-10.4c0-5.5,4.4-9.8,12.7-9.8c6.3,0,12.3,4,13.1,11h-8.1 c-0.2-2.4-2.6-3.7-5.2-3.7c-3.2,0-4.5,1.1-4.5,2.6c0,1.9,2.9,2.8,5.7,3.8c6.9,2.3,12.2,4.6,12.2,10.9c0,6.7-5.8,10.5-12.8,10.5 c-7.2,0-13-4.2-13.8-11.2h8.1c0.4,2.7,2.9,4,6,4C151.3,30.8,153.1,29.9,153.1,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.7,21.8c0-2.9-0.9-10.3-15.7-17.2c-1-0.4-5.5-2.4-11.3-1.7c-0.7,0.1-4.7,1-4.8,1.8s-0.5,13.9-0.2,15.9 s0,9.8,0,12.4c0,2.6,1.9,4.5,5,5.1c0.4,0.1,4.7,1.3,11.3-0.7C98.8,33.4,99.8,24.7,99.7,21.8z M75.3,10.6 c12.3-0.1,18.2,8.6,18.2,11.1c-0.2,5.7-11.3,8.4-18,9.2C75.5,30.3,75.3,15.3,75.3,10.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,47.4c0.6,0,1.1,0.1,1.6,0.2c0.9,0.3,1.4,1,1.4,2.2v0c0,0.6-0.1,1-0.4,1.4c-0.5,0.7-1.3,1-2.5,1H7.2v-4.8 H9.4z M8.1,51.4h1.4c0.5,0,0.8,0,1.1-0.2c0.6-0.2,0.9-0.7,0.9-1.5v0c0-1.2-0.8-1.7-2.1-1.7H8.1V51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,52.2v-4.8h4.6v0.7h-3.7v1.4h3.2v0.7h-3.2v1.3h3.9v0.7H15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,52.2H23v-4.8h0.8l2.1,2.2l2.2-2.2h0.8v4.8H28v-3.7l-2.1,2.1h-0.1l-2-2.1V52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,51l-0.6,1.2h-0.9l2.5-4.8h0.9l2.5,4.8h-0.9L35.9,51H33.1z M33.4,50.3h2.2l-1.1-2.2L33.4,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,51.4h1.3v-3.3h-1.3v-0.8h3.4v0.8h-1.3v3.3h1.3v0.8h-3.4V51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.3,52.2h-0.8v-4.8h0.9l3.2,3.5l0.2,0.2v-3.7h0.8v4.8h-0.8l-3.3-3.6l-0.2-0.2V52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.4,52.1c-0.8-0.3-1.2-0.8-1.3-1.6h0.9c0.2,0.8,0.8,1.1,2,1.1c1.1,0,1.6-0.3,1.6-0.8c0-0.2-0.1-0.3-0.2-0.4 c-0.3-0.2-0.8-0.2-1.8-0.3c-0.5,0-0.9-0.1-1.2-0.2c-0.7-0.2-1-0.5-1-1.2c0-0.9,0.8-1.5,2.3-1.5c1.6,0,2.5,0.5,2.7,1.6h-0.9 c-0.1-0.7-0.8-0.9-1.8-0.9c-1.1,0-1.5,0.3-1.5,0.7c0,0.2,0,0.3,0.1,0.4c0.2,0.2,0.7,0.3,1.6,0.3c0.6,0,1,0.1,1.4,0.2 c0.7,0.2,1.1,0.5,1.1,1.2c0,1-0.8,1.6-2.4,1.6C60.3,52.3,59.8,52.3,59.4,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,52.2v-4.8h4.6v0.7h-3.7v1.4h3.2v0.7h-3.2v1.3H71v0.7H66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.7,52.2h-0.8v-4.8h2.6c1.7,0,2.3,0.5,2.3,1.5c0,0.7-0.4,1.1-1.1,1.3c0.7,0.2,1,0.6,1,1.4v0.3 c0,0.1,0,0.3,0.1,0.3h-0.9c-0.1,0-0.1-0.2-0.1-0.3v-0.3c0-0.3,0-0.5-0.1-0.7c-0.2-0.3-0.6-0.4-1.3-0.4h-1.7V52.2z M77.2,49.7 c0.5-0.1,0.7-0.3,0.7-0.8v-0.1c0-0.6-0.5-0.8-1.5-0.8h-1.7v1.7h1.7C76.7,49.8,77,49.7,77.2,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,51l-0.6,1.2h-0.9l2.5-4.8h0.9l2.5,4.8h-0.9L85.8,51H82.9z M83.2,50.3h2.2l-1.1-2.2L83.2,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.5,52.2h-0.8v-4.8h4.4v0.7h-3.6v1.5h3.4v0.7h-3.4V52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,52c-0.9-0.4-1.4-1.1-1.4-2.2v0c0-0.5,0.1-1,0.4-1.4c0.5-0.8,1.4-1.2,2.5-1.2c0.5,0,1,0.1,1.5,0.3 c0.9,0.4,1.4,1.1,1.4,2.3v0c0,0.6-0.1,1-0.4,1.4c-0.5,0.7-1.4,1.1-2.5,1.1C103,52.3,102.6,52.2,102.1,52z M104.6,51.4 c0.6-0.2,1-0.7,1-1.6c0-0.4-0.1-0.8-0.3-1c-0.3-0.5-0.9-0.8-1.8-0.8c-1.2,0-2,0.6-2,1.8v0c0,0.4,0.1,0.7,0.3,1 c0.3,0.5,0.9,0.8,1.7,0.8C104,51.6,104.3,51.5,104.6,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.3,52.2h-0.8v-4.8h2.6c1.7,0,2.3,0.5,2.3,1.5c0,0.7-0.4,1.1-1.1,1.3c0.7,0.2,1,0.6,1,1.4v0.3 c0,0.1,0,0.3,0.1,0.3h-0.9c-0.1,0-0.1-0.2-0.1-0.3v-0.3c0-0.3,0-0.5-0.1-0.7c-0.2-0.3-0.6-0.4-1.3-0.4h-1.7V52.2z M112.8,49.7 c0.5-0.1,0.7-0.3,0.7-0.8v-0.1c0-0.6-0.5-0.8-1.5-0.8h-1.7v1.7h1.7C112.3,49.8,112.6,49.7,112.8,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.3,52.2h-0.8v-4.8h0.8l2.1,2.2l2.2-2.2h0.8v4.8h-0.8v-3.7l-2.1,2.1h-0.1l-2-2.1V52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.6,51l-0.6,1.2H126l2.5-4.8h0.9l2.5,4.8h-0.9l-0.6-1.2H127.6z M127.9,50.3h2.2l-1.1-2.2L127.9,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.9,52.2h-0.9v-4.1h-1.9v-0.7h4.7v0.7h-2V52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.6,51.4h1.3v-3.3h-1.3v-0.8h3.4v0.8h-1.3v3.3h1.3v0.8h-3.4V51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.9,52c-0.9-0.4-1.4-1.1-1.4-2.2v0c0-0.5,0.1-1,0.4-1.4c0.5-0.8,1.4-1.2,2.5-1.2c0.5,0,1,0.1,1.5,0.3 c0.9,0.4,1.4,1.1,1.4,2.3v0c0,0.6-0.1,1-0.4,1.4c-0.5,0.7-1.4,1.1-2.5,1.1C148.8,52.3,148.3,52.2,147.9,52z M150.4,51.4 c0.6-0.2,1-0.7,1-1.6c0-0.4-0.1-0.8-0.3-1c-0.3-0.5-0.9-0.8-1.8-0.8c-1.2,0-2,0.6-2,1.8v0c0,0.4,0.1,0.7,0.3,1 c0.3,0.5,0.9,0.8,1.7,0.8C149.8,51.6,150.1,51.5,150.4,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.1,52.2h-0.8v-4.8h0.9l3.2,3.5l0.2,0.2v-3.7h0.8v4.8h-0.8l-3.3-3.6l-0.2-0.2V52.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfdas);
export default __webpack_public_path__ + "static/media/afdas.1d1228e5996ef87ac317065c707f6dbf.svg";
export { ForwardRef as ReactComponent };